var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGmpMain(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 49,
    viewBox: "0 0 40 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.994 26.7469C37.994 37.995 30.1203 43.619 20.7619 46.881C20.2718 47.0471 19.7395 47.0391 19.2546 46.8585C9.87368 43.619 2 37.995 2 26.7469V10.9995C2 10.4029 2.23701 9.83067 2.6589 9.40878C3.08079 8.98689 3.65299 8.74988 4.24962 8.74988C8.74887 8.74988 14.3729 6.05033 18.2873 2.63091C18.7639 2.22372 19.3701 2 19.997 2C20.6238 2 21.2301 2.22372 21.7067 2.63091C25.6435 6.07283 31.2451 8.74988 35.7443 8.74988C36.341 8.74988 36.9132 8.98689 37.3351 9.40878C37.757 9.83067 37.994 10.4029 37.994 10.9995V26.7469Z",
    stroke: "#CCA466",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.61328 24.4991L16.5352 31.421L30.379 17.5771",
    stroke: "#CCA466",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmpMain);
export default __webpack_public_path__ + "static/media/GMP_main.5fb3c4a7cfdc4bc0bbd4d87138cc111f.svg";
export { ForwardRef as ReactComponent };